// USA
export const locale = {
  LANGUAGE: "Language",
  BULGARIAN: "Bulgarian",
  ENGLISH: "English",
  HELLO: "Hello",
  PLEASE_CHANGE_YOUR_PASSWORD: "Please change your password",
  EXIT: "Exit",
  HOME: "Home",
  PRODUCTS: "Products",
  EDIT_PRODUCT: "Edit product",
  RAW_PRODUCTS: "Raw products",
  EDIT_RAW_PRODUCT: "Edit raw product",
  MATERIALS: "Materials",
  EDIT_MATERIAL: "Edit material",
  MATERIAL_REQUIREMENTS: "Material requirements",
  EDIT_MATERIAL_REQUIREMENT: "Edit material requirement",
  VENDORS: "Vendors",
  EDIT_VENDOR: "Edit vendor",
  PRINTING_HOUSES: "Printing houses",
  EDIT_PRINTING_HOUSE: "Edit printing house",
  CLIENTS: "Clients",
  EDIT_CLIENT: "Edit client",
  OPERATORS: "Operators",
  EDIT_OPERATOR: "Edit operator",
  OPERATOR_HOLIDAYS: "Operator holidays",
  WAREHOUSES: "Warehouses",
  EDIT_WAREHOUSE: "Edit warehouse",
  USERS: "Users",
  EDIT_USER: "Edit user",
  PROFILE: "Profile",
  MATERIAL_REQUEST: "Material request",
  EDIT_MATERIAL_REQUEST: "Edit material request",
  CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS: "Certificate of release of packaging materials",
  EDIT_CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS: "Edit certificate of release of packaging materials",
  DESTRUCTION_PROTOCOL_OF_SECONDARY_PACKAGING_MATERIALS: "Destruction protocol of secondary packaging materials",
  EDIT_DESTRUCTION_PROTOCOL_OF_SECONDARY_PACKAGING_MATERIALS: "Edit destruction protocol of secondary packaging materials",
  INVOICES: "Invoices",
  EDIT_INVOICE: "Edit invoice",
  STATISTICS: "Statistics",
  QUANTITY_IN_STOCK: "Quantity in stock",
  NORMS: "Norms",
  SETTINGS: "Settings",
  WORK_BREAKS: "Work breaks",
  EDIT_WORK_BREAK: "Edit work break",
  WORKING_TIME: "Working time",
  SCRAP_REGISTER: "Scrap register",
  SAMPLE_REGISTER: "Sample register",
  CERTIFICATE_OF_RELEASE_FOR_SALE_OF_FINAL_PRODUCT: "Certificate of Conformance",
  EMAILS: "Emails",
  EDIT_EMAIL: "Edit email",
  ROUTE_MAPS_FOR_LOADING: "Route maps for loading",
  LOGS: "Logs",
  ROUTE_MAP: "Route map",
  NEW_ROUTE_MAPS: "New route maps",
  CURRENT_ROUTE_MAPS: "Current route maps",
  ROUTE_MAP_OPERATIONS: "Route map operations",
  EDIT_ROUTE_MAP: "Edit route map",
  DONE_ROUTE_MAPS: "Done route maps",
  HALLS: "Halls",
  EDIT_HALL: "Edit hall",
  LOGIN: "Login",
  TWO_FACTOR_AUTHENTICATION: "Two factor authentication",
  REGISTRATION: "Registration",
  FORGOTTEN_PASSWORD: "Forgotten password",
  RESET_PASSWORD: "Reset password",
  MODULES: "Modules",
  ROUTE_MAPS: "Route maps",
  NOMENCLATURE: "Nomenclature",
  DOCUMENTS: "Documents",
  CREATE: "Create",
  NEW_ROUTE_MAPS_MENU: "New",
  CURRENT: "Current",
  DONE: "Done",
  APPROVE_REANALYSIS: "Approve reanalysis",
  SOMETHING_WENT_WRONG: "Something went wrong",
  ARCHIVE: "Archive",
  REANALYSIS_REQUEST: "Reanalysis request",
  DECLINE_REANALYSIS: "Decline reanalysis",
  DELETE: "Delete",
  DELETE_CONFIRMATION: "Are you sure you want to delete this record?",
  DELETE_CONFIRMATION_DESCRIPTION: "This action cannot be undone!",
  DELETE_CONFIRMATION_DESCRIPTION_SAVE_CHANGES: "To complete this action, you must save the changes!",
  OK_TEXT: "OK",
  CANCEL_TEXT: "Cancel",
  EDIT: "Edit",
  PREVIEW: "Preview",
  PRINT_STICKERS: "Print stickers",
  PRINTING_STICKERS: "Printing stickers",
  PRINTER_WORKING_CHECK: "Please make sure the printer is working and is connected to your computer!",
  LOAD_PRINTER: "Please load the printer",
  WITH_SHORT: "with",
  WITH_LONG: "with",
  STICKERS: "stickers",
  NO_PRINTER_CONNECTION: "No printer connection",
  CERTIFICATE: "Certificate",
  COUNT: "Quantity",
  PRINT: "Print",
  STICKER_STATUS_FREE: "RELEASED",
  STICKER_STATUS_BLOCKED: "BLOCKED",
  STICKER_STATUS_PROBATION: "QUARANTINE",
  STICKER_COLOR_GREEN: "GREEN",
  STICKER_COLOR_RED: "RED",
  STICKER_COLOR_YELLOW: "YELLOW",
  PROCESS_REANALYSIS: "Process reanalysis",
  SIGN: "Sign",
  LOG: "Log",
  EMAIL_NOT_FOUND: "Email not found!",
  CERTIFICATE_CANNOT_BE_DELETED_BECAUSE_IT_IS_IN_PRODUCTION_OR_HAS_DESTROYED_BATCHES: "The certificate cannot be deleted because it is in production or has destroyed batches from it!",
  MATERIAL_PROPERTY_CANNOT_BE_DELETED_BECAUSE_IT_IS_CONNECTED_TO_MATERIALS: "The material property cannot be deleted because it is connected to materials!",
  ACCEPTANCE_ACT_CANNOT_BE_DELETED_BECAUSE_IT_IS_IN_PRODUCTION: "The acceptance act cannot be deleted because it is in production!",
  MATERIAL_CANNOT_BE_DELETED_BECAUSE_IT_HAS_CERTIFICATES: "The material cannot be deleted because it has connected certificates!",
  CLIENT: "Client",
  DATE: "Date",
  BATCH: "Batch",
  QUANTITY: "Quantity",
  RAW_PRODUCT: "Raw product",
  EXPIRATION_DATE: "Expiration date",
  FROM_WAREHOUSE: "From warehouse",
  TO_WAREHOUSE: "To warehouse",
  ADD_RECORD: "Add record",
  CREATED_AT: "Created at",
  UPDATED_AT: "Updated at",
  NAME: "Name",
  ACTIONS: "Actions",
  DOWNLOAD: "Download",
  DOWNLOAD_DOCUMENT: "Download document",
  ADD: "Add",
  ACCEPTANCE_ACT: "Acceptance act",
  ERROR: "Error",
  PAGE_NOT_FOUND: "Page not found!",
  OPERATIONS: "Operations",
  DOWNLOAD_DOCUMENT_ACCEPTANCE_ACT: "Download AA document",
  PURCHASER: "Purchaser",
  BATCH_NUMBER_OF_PRODUCER: "Batch number of producer",
  PRINTING_HOUSE: "Printing house",
  DELIVERY_DATE: "Delivery date",
  CONCLUSION_PROTOCOL: "Conclusion (Protocol)",
  CONCLUSION_CERTIFICATE: "Conclusion (Certificate)",
  CONCLUSION_PROTOCOL_DESCRIPTION: "The packaging materials meet the accompanying documentation (AA, expedition order, request), sampling has been carried out and the corresponding BOM is to be certified /PLEASE FILL IN/",
  MATERIAL: "Material",
  MODIFY: "Modify",
  CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIAL: "Certificate of release of packaging material",
  CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS: "Certificate of release of packaging materials",
  ARCHIVED: "Archived",
  DOWNLOAD_REGISTER_FOR_RECEIVING_AND_REGISTERING_INTERNAL_BATCH_NUMBER_OF_BOM: "Download register for receiving and registering internal batch number of BOM",
  SEARCH_BY_YEAR: "Search by year",
  SIGNED: "Signed",
  QUARANTINE: "Quarantine",
  YES: "Yes",
  NO: "No",
  GENERATE_CERTIFICATE: "Generate certificate",
  RETURN_TO_QUARANTINE_STATUS: "Return to quarantine status",
  DOWNLOAD_CERTIFICATE: "Download certificate",
  DOWNLOAD_PROTOCOL: "Download protocol",
  CONNECTED_RM: "Connected RM",
  GENERATING_OF_CERTIFICATE: "Generating of certificate",
  STATUS: "Status",
  MEETS: "Meets",
  DOES_NOT_MEETS: "Does not meets",
  GENERATE: "Generate",
  CONNECTED_ROUTE_MAPS: "Connected route maps",
  MANAGER: "Manager",
  NO_RESULTS_FOUND: "No results found",
  CONCLUSION_CERTIFICATE_DESCRIPTION: "The packaging materials meet the requirements of the approved specification for the certification of packaging material of a {type} - SP BP QQ № /PLEASE FILL IN/",
  REASONS: "Reasons",
  CERTIFICATE_CANNOT_BE_GENERATED_BECAUSE_THE_STATUS_IS_NOT_FREE_AND_MEETS_ALL_REQUIREMENTS: "In order to generate the certificate and use the materials, the status must be \"Free\" and meet all requirements",
  STATUS_FIELD_IS_REQUIRED: "The status field is required",
  THE_FIELD: "The field",
  IS_REQUIRED: "is required",
  FREE: "Free",
  RELEASED: "Released",
  BLOCKED: "Blocked",
  THE_FIELD_IS_REQUIRED: "The field is required",
  EIK: "EIK",
  MOL: "MRP",
  MATERIALLY_RESPONSIBLE_PERSON: "Materially responsible person",
  NUMBER_BY_VAT: "Number by VAT",
  BANK: "Bank",
  CONTACT: "Contact",
  COUNTRY: "Country",
  CITY: "City",
  ADDRESS: "Address",
  ADD_NEW_USER: "Add new user",
  SAVE: "Save",
  WELCOME_TO_THE_SYSTEM: "Welcome to the system of Besta Pharmaceuticals!",
  COUNTS: "Counts",
  REMAINING: "remaining",
  MADE: "made",
  INTERNAL_BATCH_NUMBER: "Internal batch number",
  REASONS_FOR_DESTROYING: "Reasons for destroying",
  PROTOCOL_FOR_DESTROYING_SECONDARY_PACKAGING_MATERIALS: "Protocol for destroying secondary packaging materials",
  COUNT_ABBREVIATION: "pcs.",
  EMAIL: "Email",
  THE_FIELD_MUST_BE_AT_LEAST: "The field must be at least",
  THE_FIELD_MUST_BE_AT_MOST: "The field must be at most",
  CHARACTERS: "characters",
  USERS: "Users",
  SEND_EMAIL_TO_QUALITY_CONTROL_WHEN_OPERATOR_CHECKS_IN_PAUSED_RM: "Send email to quality control when operator checks in paused RM",
  PASSWORD: "Password",
  CONFIRM_PASSWORD: "Confirm password",
  NO_ACTIVE_ROUTE_MAP_IN_THIS_HALL: "No active route map in this hall",
  SUCCESSFUL_OPERATION: "Successful operation",
  WRONG_OPERATOR_CODE: "Wrong operator code",
  CONTROL_CODE: "Control code",
  ADD_OPERATOR: "Add operator",
  BATCH_NUMBER: "Batch №",
  RAW_PRODUCT_SCRAP: "Raw product scrap",
  START: "Start",
  HALL_IS_MARKED_FOR_CLEANING: "Hall is marked for cleaning",
  HALL_IS_NOT_LOADED_WITH_RAW_PRODUCTS_AND_MATERIALS: "Hall is not loaded with raw products and materials. Loading is planned for",
  HALL_IS_MARKED_FOR_RELOADING: "Hall is marked for reloading",
  PLEASE_PERFORM_QUALITY_CONTROL: "Please perform quality control!",
  CONTROL: "Control",
  HOUR_ABBR: "h.",
  MINUTE_ABBR: "min.",
  SECOND_ABBR: "sec.",
  YEAR_ABBR: "y.",
  CANCEL: "Cancel",
  OPERATOR_CODE: "Operator code",
  OPERATOR_SIGNATURE_CODE: "Operator signature code",
  FINISH_WORK_ON: "Finish work on",
  OPERATOR: "Operator",
  OPERATION: "Operation",
  CHOOSE: "Choose",
  ADD_NEW_OPERATION: "Add new operation",
  FINISH_WORK: "Finish work",
  BACK: "Back",
  LEAVE_THIS_ROUTE_MAP: "Leave this route map",
  THE_QUANTITY_OF_SCRAP_MATERIALS_MUST_BE_AT_LEAST: "The quantity of scrap materials must be at least",
  PLEASE_FILL_IN_ALL_FIELDS_CORRECTLY: "Please fill in all fields correctly",
  PERFORMED_OPERATIONS: "Performed operations",
  CORRECTED: "corrected",
  INVOICE: "Invoice",
  NUMBER: "Number",
  GENERATE_INVOICE: "Generate invoice",
  PRODUCT: "Product",
  PRODUCT_TYPE: "Product type",
  ROUTE_MAP_NUMBER: "Route map number",
  PRICE_PER_UNIT_WITHOUT_VAT: "Price per unit without VAT",
  START_DATE: "Start date",
  END_DATE: "End date",
  SEND: "Send",
  NO_RESULTS_FOUND_FOR_THIS_PERIOD: "No results found for this period",
  ADD_NEW_INVOICE: "ADD NEW INVOICE",
  DOWNLOAD_INVOICE: "Download invoice",
  HALL_IS_MARKED_FOR_CORRECTION_BECAUSE_OF_THE_FOLLOWING_REASONS: "Hall is marked for correction because of the following reasons",
  EXTERNAL_APPEARANCE_COLOR_AND_COMPLETENESS_OF_THE_PACKAGING: "External appearance, color, completeness of the packaging",
  PRODUCT_COMPLIANCE_WITH_THE_INSTRUCTIONS_FOR_REPACKAGING: "Product compliance with the instructions for repackaging",
  CLARITY_AND_VERACITY_OF_THE_BATCH_NUMBER_AND_EXPIRATION_DATE: "Clarity and veracity of the batch number and expiration date",
  REMARKS: "Remarks",
  CONFIRM_THAT_THE_HALL_IS_LOADED: "Confirm that the hall is loaded",
  CONFIRM_THAT_THE_HALL_IS_CORRECTED: "Confirm that you have corrected the hall",
  NO_ROUTEMAPS_FOR_LOADING: "No route maps for loading",
  NO_CHANGES_MADE: "No changes made",
  ADD_NEW_VALUE: "Add new value",
  VALUE: "Value",
  VALUES: "Values",
  SEARCH_BY_COLUMN: "Search by column",
  NUMBER_OF_PRIMARY_UNITS: "Number of primary units",
  NUMBER_OF_PACKAGES: "Number of packages",
  SENT_EMAIL: "Sent email",
  CREATE_ACCEPTANCE_ACT: "Create AA",
  SEND_EMAIL: "Send email",
  DOWNLOAD_ACCEPTANCE_ACT: "Download AA",
  DOWNLOAD_REQUEST_BLANK: "Download REQUEST blank",
  CREATE_ACCEPTANCE_ACT_FROM_THIS_REQUEST: "Create acceptance act from this request",
  SENDING_EMAIL: "Sending email",
  MESSAGE: "Message",
  APPLY_FOR_REQUEST_NUMBER: "Hello, we apply for request number",
  CHOOSE_EMAILS: "Choose emails",
  REQUIREMENTS_TO_MATERIALS: "Requirements to materials",
  TYPE_OF_REQUIREMENT: "Type of requirement",
  REQUIREMENT: "Requirement",
  MATERIAL_TYPE: "Material type",
  REMARK: "Remark",
  OPERATOR_LOGIN: "Operator login",
  CODE: "Code",
  REMAINING_COUNTS: "Remaining counts",
  BEGIN: "Begin",
  LAST_NAME: "Last name",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SIGNATURE_CODE: "Signature code",
  HOLIDAYS: "Holidays",
  RECIPES: "Recipes",
  INSTRUCTION_NUMBER: "Instruction number",
  ADD_MATERIAL: "Add material",
  NORM: "Norm",
  COUNT_OF_BOXES_IN_BOX: "Count of boxes in box",
  PRIMARY_PACKAGES_IN_BOX: "Primary packages in box",
  COUNT_OF_MEDICINAL_UNITS_IN_PRIMARY_PACKAGE: "Count of medicinal units in primary package",
  SELLING_PRICE_UP_TO_5000_PIECES: "Selling price up to 5000 pieces",
  SELLING_PRICE_OVER_5000_PIECES: "Selling price over 5000 pieces",
  ADD_NEW_PRODUCT: "Add new product",
  STRENGTH: "Strength",
  MEDICINAL_FORM: "Medicinal form",
  CHOOSE_VENDORS: "Choose vendors",
  CHOOSE_MANUFACTURE_TYPES: "Choose manufacture type",
  AUTHORIZATION_HOLDER: "Authorization holder",
  REGISTER_OF_CERTIFICATE_OF_RELEASE_FOR_THE_SALE_OF_FINAL_PRODUCT: "Register of \"Certificate of release for the sale of final product\"",
  DOWNLOAD_EXPORT: "Download export",
  GENERATE_PROTOCOL: "Generate protocol",
  GENERATING_OF_PROTOCOL: "Generating of protocol",
  FARMACEUTICAL_FORM: "Pharmaceutical form",
  HOLDER_OF_PARALLEL_IMPORT_PERMISSION: "Holder of parallel import permission",
  BATCH_SIZE: "Batch size",
  PURCHASER_FOR_REPACKAGING: "Purchaser for repackaging",
  EXPIRATION_DATE_OF_STORAGE_OF_MUSEUM_DISPLAY: "Expiration date of storage of museum display",
  INSUFFICIENT_QUANTITY_OF_RAW_PRODUCT: "Insufficient quantity of raw product",
  LOADING_DATE_AND_TIME: "Loading date and time",
  MATERIAL_CONSUMPTION_NORM: "Material consumption norm",
  IN_THE_WAREHOUSE_FOR_MUSEUM_DISPLAYS_ALREADY_HAS_A_SAMPLE_FOR_THIS_BATCH: "In the warehouse for museum displays already has a sample for this batch number.",
  IN_THE_WAREHOUSE_FOR_BOM_DISPLAYS_ALREADY_HAS_A_SAMPLE: "In the warehouse for BOM displays already has a sample.",
  STICKER: "Sticker",
  INFORMATION_ABOUT_ROUTE_MAP: "Information about the route map",
  CURRENT_CONTROL_DURING_REPACKAGING_AND_LABELING: "Current control during repackaging and labeling",
  EXTERNAL_VIEW_COLOR: "External view, color",
  OVERALL_PACKAGING: "overall packaging",
  TIME: "Time",
  PRODUCT_CONFORMITY_WITH: "Product conformity with",
  INSTRUCTIONS_FOR_REPACKAGING: "instructions for repackaging",
  LEGIBILITY_AND_ACCURACY_OF_THE_BATCH_NUMBER_AND_EXPIRY_DATE_INSCRIPTIONS: "Legibility and accuracy of the batch number and expiry date inscriptions",
  COMPLETED_CONTROL: "Completed control",
  DATE_AND_TIME: "Date and time",
  SAVE_CONTROL: "Save control",
  MEDICINAL_PRODUCT: "Medicinal product",
  READY: "Ready",
  DESCRIPTION_OF_OUTPUT_RAW_MATERIALS_AND_PACKAGING_MATERIALS: "Description of output raw materials / packaging materials",
  PARTICIPANTS_IN_SECONDARY_REPACKAGING: "Participants in secondary repackaging",
  SCRAP: "Scrap",
  SAVE_OPERATION: "Save operation",
  STATUSES: "Statuses",
  DOWNLOAD_FULL_DOCUMENT: "Download full document",
  FILES: "Files",
  REGENERATE_DOCUMENT: "Regenerate document",
  EDIT_AUTHORIZATION_HOLDER: "Edit authorization holder",
  EDIT_BLOCKING_INFORMATION: "Edit blocking information",
  BLOCK: "Block",
  BLOCK_ROUTE_MAP: "Block route map",
  UPLOAD_FILE: "Upload file",
  DOCUMENT_TITLE: "Document title",
  UPLOAD: "Upload",
  ALL: "All",
  REASON: "Reason",
  PRINTOUT: "Printout",
  EDIT_HALLS: "Edit halls",
  QUALITY_CONTROL_AFTER: "Quality control after",
  ARCHIVE_ROUTE_MAP_CONFIRMATION: "Are you sure you want to archive this route map? This action cannot be undone!",
  NOTE: "Note",
  THE_FIELD_NOTE_IS_REQUIRED: "The field note is required",
  ARCHIVE_CONFIRMATION: "Are you sure you want to archive",
  ARCHIVE_CONFIRMATION_DESCRIPTION: "This action cannot be undone!",
  FINISH_ROUTE_MAP_CONFIRMATION: "Are you sure you want to finish this route map?",
  NOT_ALL_COUNTS_ARE_COMPLETED: "Not all counts are completed. Remaining",
  CONFIRM: "Confirm",
  NUMBER_OF_SCRAP_MATERIALS: "Number of scrap materials",
  PLEASE_CHOOSE_MATERIAL: "Please choose material",
  THE_NUMBER_OF_SCRAP_MATERIALS_MUST_BE_AT_LEAST_1: "The number of scrap materials must be at least 1",
  PLEASE_CHOOSE_OPERATION: "Please choose operation",
  THE_NUMBER_OF_PERFORMED_OPERATIONS_MUST_BE_AT_LEAST_1: "The number of performed operations must be at least 1",
  CHECKING_OPERATOR: "Checking operator",
  PLEASE_CHOOSE_OPERATOR: "Please choose operator",
  FINISH_WORK_ON: "Finish work on",
  FINISH: "Finish",
  COMMENT: "Comment",
  MARK_HERE_IF_NEEDED_FOR_CLEANING: "Mark here if needed for cleaning!",
  PAUSE: "Pause",
  THE_FIELD_COMMENT_IS_REQUIRED: "The field comment is required",
  PERFORM_QUALITY_CONTROL: "Perform quality control",
  SEND_TO_LABOURER: "Send to labourer",
  PERFORM_CONTROL: "Perform control",
  NUMBER_OF_SCRAP_RAW_PRODUCTS: "Number of scrap raw products",
  THE_NUMBER_OF_SCRAP_RAW_PRODUCTS_MUST_BE_AT_LEAST_1: "The number of scrap raw products must be at least 1",
  MINUTES_OF_PAUSE_FROM: "Minutes of pause from",
  TO: "to",
  REMAINING_TIME: "Remaining time",
  PLEASE_CONFIRM_THAT_THE_CLEANING_HAS_BEEN_PERFORMED: "In order to continue working, please confirm that the cleaning has been performed!",
  THE_LAST_WORKING_DAY_HAS_REMAINED: "The last working day has remained",
  MINUTES_TO_QUALITY_CONTROL: "minutes to quality control.",
  PLEASE_CHECK_IN_AS_AN_OPERATOR_TO_START_THE_WORK_PROCESS: "Please check in as an operator, to start the work process!",
  HALL_IS_MARKED_FOR_RELOADING_BECAUSE_OF_THE_FOLLOWING_REASONS: "Hall is marked for reloading because of the following reasons",
  EXTERNAL_VIEW_COLOR_AND_OVERALL_PACKAGING: "External view, color, overall packaging.",
  CHECKED_OPERATORS: "Checked operators",
  FINISH_WORK_ON_THIS_ROUTE_MAP: "Finish work on this route map",
  COMMENTS: "Comments",
  ADD_COMMENT: "Add comment",
  MATERIAL_SCRAP: "Material scrap",
  CHECK_OPERATOR: "Check operator",
  FINISH_ROUTE_MAP: "Finish route map",
  QUALITY_CONTROL: "Quality control",
  FIRST_CONTROL_OF_THE_DAY: "First control of the day",
  LAST_CONTROL_PERFORMED: "Last control performed",
  PERFORMED_CONTROLS_TODAY: "Performed controls today",
  NEXT_PAUSE: "Next pause",
  MINUTES_FROM: "minutes from",
  THERE_IS_NO: "There is no",
  PERFORMED_PAUSES_TODAY: "Performed pauses today",
  PERFORMED_CHARGING: "Performed charging",
  ON: "on",
  USER: "User",
  CORRECTION: "Correction",
  PERFORMED_QUALITY_CONTROL: "Performed quality control",
  CLARITY_AND_VERACITY_OF: "Clarity and veracity of",
  BATCH_NUMBER_AND_EXPIRATION_DATE: "batch number and expiration date",
  QUANTITY_FOR_PRODUCTION: "Quantity for production",
  READY_QUANTITY: "Ready quantity",
  REMAINING_QUANTITY: "Remaining quantity",
  INSERTED_QUANTITY: "Inserted quantity",
  SAMPLE: "Sample",
  RETURNED: "Returned",
  BEGINNING: "Beginning",
  END: "End",
  PRODUCER_BATCH_NUMBER: "Producer batch number",
  ROLE: "Role",
  APP_TITLE: "Besta Pharmaceuticals",
  PLEASE_RELOAD_THE_PAGE_AND_TRY_AGAIN: "Please reload the page and try again",
  TABLE: "Table",
  PER_PAGE: "Results per page",
  RESULTS: "results",
  SEARCH: "Search",
  NO_DATA: "No data",
  NEW: "New",
  NEWO: "New",
  NEWA: "New",
  ADD_REQUIREMENT: "Add new requirement",
  ADD_RECIPE: "Add new recipe",
  ADD_HALL: "Add new hall",
  ADD_EMAIL: "Add new email",
  ADD_DESTRUCTION_PROTOCOL: "Add new destruction protocol",
  READY: "Ready",
  EXPORT: "Export",
  FROM: "from",
  WORK_BREAK: "Work break",
  VENDOR: "Vendor",
  MANUFACTURE_TYPES: "Manufacture type",
  WAREHOUSE: "Warehouse",
  MATERIAL_REQUIREMENT: "Material requirement",
  ENTER_VALID_EMAIL: "Enter valid email.",
  PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
  PASSWORD_IS_REQUIRED: "Password is required.",
  TO_PROCEED_ENTER_EMAIL_CODE: "To proceed, enter the 6-digit code sent to your email!",
  ENTER_VALID_CODE: "Enter valid code.",
  FORGOT_PASSWORD: "Forgot password?",
  PASSWORD_RESET_LINK_SENT: "You will receive an email with a link to reset your password.",
  ENTER_YOUR_EMAIL_TO_RESET_PASSWORD: "Enter your email, to reset your password!",
  ENTER_YOUR_NEW_PASSWORD: "Enter your new password",
  CONFIRM_PASSWORD: "Confirm password",
  HOLIDAYS_FOR_OPERATORS: "Holidays for operators",
  ADD_HOLIDAY: "Add holiday",
  EDIT_HOLIDAY: "Edit holiday",
  END_DATE_MUST_BE_GREATER_THAN_START_DATE: "The end date must be greater than the start date",
  ADD_NEW_FORM_TYPE: "Add new medicinal form",
  FORM_TYPE_ADDED_SUCCESSFULLY: "The medicinal form has been added successfully",

  LABELS: {
    acceptanceActDetail: {
      expirationDate: "Expiration date",
      batch: "Batch number",
      acceptanceAct: {
        client: {
          name: "Purchaser"
        }
      }
    },
    documentType: "Document type",
    routeMap: {
      certificate: {
        id: "id",
        signedAt: "Date",
        number: "Certificate number"
      },
      certificateNumber: {
        number: "Certificate number"
      },
      id: "id",
      finishDate: "Creation date",
      product: {
        name: "Name and concentration"
      }
    },
    materialName: "Material",
    login: {
      email: "Email"
    },
    client: {
      name: "Client"
    },
    LOG_BTN: "Log",
    sealCode: "Manager code",
    createdAt: "Created on",
    address: "Address",
    id: "ID",
    name: "Name",
    email: "Email",
    values: "Values",
    role: "Role",
    strength: "Concentration",
    "raw-product": {
      name: "Name",
      strength: "Concentration",
      ma_holder: "Authorization holder",
      primary_q_i_b: "Primary packages in box",
      vendor: {
        name: "Name"
      },
      formType: {
        name: "Medicinal form"
      },
      manufactureType: {
        name: "Manufacture type",
      },
      note: "Note"
    },
    "destruction-packaging-material": {
      signed_by_qualified: "Signed",
      client: {
        name: "Purchaser"
      },
      quantity: "Quantity",
      material: {
        name: "Material",
        type: {
          name: "Type"
        }
      },
      reason: "Reason"
    },
    "prepared-product": {
      name: "Name",
      primary_q_i_b: "Primary packages in box",
      note: "Note",
      quantity_in_medical_package:
        "Count of medicinal units in primary package",
      price_under: "Selling price up to 5000 pieces",
      price_over: "Selling price over 5000 pieces",
      q_i_b: "Count of boxes in box",
      quantity: "Quantity",
      norm: "Norm",
      typeable: {
        name: "Raw product"
      },
      product: {
        name: "Name of product"
      },
      formula: {
        name: "Name"
      },
      client: {
        name: "Client"
      }
    },
    qIB: "Boxes in box",
    primaryQIB: "Primary packages in box",
    primaryQuantity: "Primary packages",
    priceUnder: "Selling price up to 5000 pieces",
    priceOver: "Selling price over 5000 pieces",
    primary_qIB: "Primary packages in box",
    primary_quantity: "Primary packages",
    price_under: "Selling price up to 5000 pieces",
    price_over: "Selling price over 5000 pieces",
    mol: "MRP",
    eik: "EIK",
    firstName: "Name",
    lastName: "Last name",
    active: "Active",
    number: "Code",
    date: "Date",
    status_id: "status_id",
    start_date: "Start date",
    finish_date: "Finish date",
    startDate: "Start date",
    finishDate: "Finish date",
    endDate: "End date",
    quantity: "Count",
    halls: "Hall",
    batch: "Batch",
    product_raw_quantity: "Raw product quantity",
    product_quantity: "Quantity",
    instruction_id: "Instruction",
    user_id: "User ID",
    product_formula_id: "Formula ID",
    materialDate: "Loading date",
    material_date: "Loading date",
    remainQuantity: "Remaining quantity",
    readyQuantity: "Ready quantity",
    remain_quantity: "Remaining quantity",
    ready_quantity: "Ready quantity",
    operator: "Operator",
    completedNorm: "Completed norm",
    year: "Year",
    month: "Month",
    monthAverage: "Average monthly",
    norm: "Norm",
    made: "Made",
    result: "Result",
    from: "From",
    to: "To",
    startTime: "Start time",
    endTime: "End time",
    holidaysFor: "Holidays for",
    operations: "Operations",
    productManager: {
      name: "Manager"
    },
    status: {
      name: "Status"
    },
    type: {
      name: "Type"
    },
    product: {
      name: "Product"
    },

    material: {
      name: "Material",
      note: "Note",
      type: {
        name: "Type"
      },
      client: {
        name: "Client"
      },
      product: {
        name: "Name"
      },
      property: {
        name: "Requirement"
      }
    },
    invoice: {
      user: {
        name: "User"
      },
      quantity: "Quantity",
      price: "Price",
      paymentType: {
        name: "Payment type"
      },
      number: "Number",
      status: {
        name: "Status"
      },
      date: "Date"
    },
    nextControl: "Next control",
    next_control: "Next control",
    "material-details-property": {
      name: "Name",
      property: {
        name: "Name"
      }
    },
    warehouse: {
      name: "Name"
    },
    vendor: {
      name: "Name",
      address: "Address"
    },
    printery: {
      name: "Name",
      address: "Address"
    },
    clients: {
      name: "Name",
      eik: "EIK",
      mol: "MRP",
      vat: "VAT Number",
      bank: "Bank",
      iban: "IBAN",
      contact: "Contact",
      country: "Country",
      city: "City",
      address: "Address"
    },
    "material-request": {
      client: {
        name: "Client"
      },
      country: "Country",
      date: "Date",
      fromWarehouse: {
        name: "From warehouse"
      },
      toWarehouse: {
        name: "To warehouse"
      },
      rawProduct: {
        name: "Raw product"
      },
      batch: "Batch",
      buy: "Expiration date",
      quantity: "Quantity",
      number: "Number"
    },
    operators: {
      first_name: "Name",
      last_name: "Last name",
      seal_code: "Signature code",
      code: "Code",
      active: "Active"
    },
    certificate: {
      signed_by_qualified: "Signed",
      certificateType: {
        name: "Type"
      },
      material: {
        name: "Material"
      },
      batch: "Batch number",
      vendor: {
        name: "Printing house"
      },
      vendor_batch: "Producer batch number",
      quantity: "Quantity",
      user: {
        name: "User"
      },
      note: "Comment",
      status: {
        name: "Status"
      },
      delivery_date: "Delivery date",
      date: "Date",
      conclusion: "Conclusion",
      answer: "Meets",
      property: {
        name: "Indicator"
      },
      value: "Requirements",
      number: "Code",
      client: {
        name: "Client"
      }
    },
    user: {
      name: "Name",
      email: "Email",
      seal_code: "Signature code"
    },
    "route-map": {
      description: "Description",
      user: {
        name: "User"
      },
      comment_before_pause: "Comment before pause",
      comment_after_start: "Comment after pause",
      scrap: "Scrap quantity",
      returned: "Returned quantity",
      package: "External appearance, color and integrity of the packaging",
      instructions: "Correspondence of the product with the instructions for repackaging",
      batch: "Clarity and authenticity of the batch number and expiration date",
      notes: "Notes",
      nextControl: "Next control",
      next_control: "Next control",
      name: "exit raw products / packaging materials",
      status: {
        name: "Status"
      },
      operator: {
        name: "Name"
      },
      start_date: "Start date",
      finish_date: "Finish date",
      product: {
        name: "Products"
      },
      quantity: "Quantity",
      productManager: {
        name: "Manager"
      },
      product_raw_quantity: "Raw product quantity",
      product_quantity: "Raw product quantity",
      material_date: "Loading date and time"
    }
  },
  LABEL_LOGS: {
    emails: {
      email: "Email"
    },
    login: {
      email: "Email"
    },
    client: {
      name: "Client"
    },
    strength: "Concentration",
    "raw-product": {
      name: "Name",
      strength: "Concentration",
      ma_holder: "Authorization holder",
      primary_q_i_b: "Primary packages in box",
      vendor: {
        name: "Name"
      },
      formType: {
        name: "Medicinal form"
      },
      manufactureType: {
        name: "Manufacture type",
      },
      note: "Note"
    },
    "work-breaks": {
      start_time: "Start",
      end_time: "End"
    },
    "destruction-packaging-material": {
      signed_by_qualified: "Signed",
      certificate: {
        number: "Code"
      },
      client: {
        name: "Purchaser"
      },
      quantity: "Quantity",
      material: {
        name: "Material",
        type: {
          name: "Type"
        }
      },
      reason: "Reason"
    },
    "prepared-product": {
      name: "Name",
      primary_q_i_b: "Primary packages in box",
      note: "Note",
      quantity_in_medical_package:
        "Count of medicinal units in primary package",
      price_under: "Selling price up to 5000 pieces",
      price_over: "Selling price over 5000 pieces",
      q_i_b: "Count of boxes in box",
      quantity: "Quantity",
      norm: "Norm",
      typeable: {
        name: "Raw product"
      },
      product: {
        name: "Name of product"
      },
      formula: {
        name: "Name"
      },
      client: {
        name: "Client"
      }
    },
    productManager: {
      name: "Manager"
    },
    status: {
      name: "Status"
    },
    type: {
      name: "Type"
    },
    product: {
      name: "Product"
    },
    material: {
      name: "Material",
      note: "Note",
      type: {
        name: "Type"
      },
      client: {
        name: "Client"
      },
      product: {
        name: "Name"
      },
      property: {
        name: "Requirement"
      },
      manufactureType: {
        name: "Manufacture type",
      },
    },
    invoice: {
      user: {
        name: "User"
      },
      quantity: "Quantity",
      price: "Price",
      paymentType: {
        name: "Payment type"
      },
      number: "Number",
      status: {
        name: "Status"
      },
      manufactureType: {
        name: "Manufacture type"
      },
      date: "Date"
    },
    "material-details-property": {
      name: "Name",
      property: {
        name: "Name"
      }
    },
    warehouse: {
      name: "Name"
    },
    vendor: {
      name: "Name",
      address: "Address"
    },
    printery: {
      name: "Name",
      address: "Address",
    },
    clients: {
      name: "Name",
      eik: "EIK",
      mol: "MRP",
      vat: "VAT Number",
      bank: "Bank",
      iban: "IBAN",
      contact: "Contact",
      country: "Country",
      city: "City",
      address: "Address",
    },
    "material-request": {
      client: {
        name: "Client"
      },
      country: "Country",
      date: "Date",
      fromWarehouse: {
        name: "From warehouse"
      },
      toWarehouse: {
        name: "To warehouse"
      },
      rawProduct: {
        name: "Raw product"
      },
      batch: "Batch",
      buy: "Expiration date",
      quantity: "Quantity",
      number: "Number",
      status: "Status",
      number_primary_units: "Count of primary units",
      packages: "Count of packages"
    },
    operators: {
      first_name: "Name",
      last_name: "Last name",
      seal_code: "Signature code",
      code: "Code",
      active: "Active"
    },
    certificate: {
      conclusion_protocol: "Conclusion (Protocol)",
      signed_by_qualified: "Signed",
      certificateType: {
        name: "Type"
      },
      material: {
        name: "Material"
      },
      batch: "Batch number",
      vendor: {
        name: "Printing house"
      },
      vendor_batch: "Producer batch number",
      quantity: "Quantity",
      user: {
        name: "User"
      },
      note: "Comment",
      status: {
        name: "Status"
      },
      delivery_date: "Delivery date",
      date: "Date",
      conclusion: "Conclusion (Certificate)",
      answer: "Meets",
      property: {
        name: "Indicator"
      },
      value: "Requirements",
      number: "Code",
      client: {
        name: "Client"
      }
    },
    user: {
      name: "Name",
      email: "Email",
      seal_code: "Signature code",
      role: {
        name: "Role"
      }
    },
    "route-map": {
      vendor: {
        name: "Producer"
      },
      reason: "Reason",
      comment: "Comment",
      authorization_holder: "Authorization holder",
      product_batch: "Batch",
      archive_note: "Note",
      sample: "Sample",
      warehouse_has_sample:
        "In the warehouse for museum displays already has a sample for this batch number.",
      description: "Description",
      date: "Date",
      signed: "Signed",
      signed_at: "Signed at",
      is_sent_to_labourer: "Sent to labourer",
      user: {
        name: "User"
      },
      finishedBy: {
        name: "Route map finished by"
      },
      operation: {
        name: "Operation name"
      },
      comment_before_pause: "Comment before pause",
      comment_after_start: "Comment after pause",
      scrap: "Scrap quantity",
      returned: "Returned quantity",
      package: "External appearance, color and integrity of the packaging",
      instructions: "Correspondence of the product with the instructions for repackaging",
      batch: "Clarity and authenticity of the batch number and expiration date",
      notes: "Notes",
      nextControl: "Next control",
      next_control: "Next control",
      name: "Exit raw products / packaging materials",
      status: {
        name: "Status"
      },
      operator: {
        name: "Name",
        first_name: "Operator first name",
        last_name: "Operator last name"
      },
      start_date: "Start date",
      finish_date: "Finish date",
      product: {
        name: "Products"
      },
      quantity: "Quantity",
      productManager: {
        name: "Manager"
      },
      product_raw_quantity: "Raw product quantity",
      product_quantity: "Raw product quantity",
      material_date: "Loading date and time"
    },
    halls: {
      name: "Name",
      login: {
        email: "Email"
      }
    },
    1: "Yes",
    0: "No",
    true: "Yes",
    false: "No"
  },
  LOGS: {
    break_finished: "End of break",
    break_added: "Start of break",
    updated: "Updated",
    break_interrupted: "Break interrupted",
    product_scrap_added: "Scrap of raw products",
    material_scrap_added: "Scrap of materials",
    operator_logout: "Operator finished work",
    operator_login: "Operator checked in",
    operation_create: "Operation created",
    cost_standard_updated: "Updated cost standard",
    control_successful: "Successful control",
    charged: "Hall is charged",
    cleaned: "Hall is cleaned",
    created: "Created",
    route_map_operation_created: "Operation created",
    created_user_role: "User connected to new role",
    deleted_user_role: "User removed from role",
    route_map_operation_deleted: "Operation deleted",
    control_failed: "Failed control",
    product_formula_was_created: "New recipe created",
    product_formula_material_was_deleted: "Instruction deleted",
    product_operation_was_created: "New operation created",
    product_operation_was_deleted: "Operation deleted",
    product_manufacturer_was_created: "Producer created",
    route_map_blocking: "Route map blocked",
    product_manufacturer_was_deleted: "Producer deleted",
    material_product_map_was_created: "Product created",
    material_detail_was_created: "New requirement created",
    material_detail_was_deleted: "Requirement deleted",
    deleted: "Deleted",
    material_detail_property_value_was_created: "New value created",
    material_detail_property_value_was_deleted: "Value deleted",
    material_request_detail_was_created: "New product created",
    material_request_detail_was_updated: "Product updated",
    material_request_detail_was_deleted: "Product deleted",
    acceptance_act_was_created: "AA created",
    certificate_result_was_created: "Indicator created",
    certificate_result_was_updated: "Indicator updated",
    destruction_protocol_product_was_created: "Product created",
    destruction_protocol_product_was_updated: "Product updated",
    destruction_protocol_product_was_deleted: "Product deleted",
    destruction_protocol_was_signed: "Protocol signed",
    invoice_detail_deleted: "Product deleted",
    invoice_detail_updated: "Product updated",
    invoice_detail_created: "Product created",
    certificate_signed_by_qualified: "Signed",
    route_map_updated_by_admin: "Updated by admin",
    route_map_updated_by_admin_printout: "Updated by admin",
    route_map_updated_printout: "Updated",
    cost_standard_updated_by_admin:
      "Cost standard updated by admin",
    cost_standard_updated_by_manager:
      "Cost standard updated by manager",
    route_map_operation_updated: "Operation updated",
    product_formula_material_was_created:
      "New instruction to recipe created",
    update_batch: "Batch updated",
    product_operation_was_updated: "Product operation updated",
    comment_added: "Comment added",
    pause_added: "Pause added",
    pause_finished: "Pause finished",
  },
  MONTHS: {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  }
};
